(function() {
'use strict';

angular
    .module('core')
    .factory('authService', authService);

function authService($rootScope,
                     $window,
                     $http,
                     $location,
                     $q,
                     $route,
                     $timeout,
                     currentUser,
                     broker,
                     urlUtils,
                     discountsService,
                     criteoService,
                     preferences,
                     analytics,
                     cookieService,
                     dateUtil,
                    accountMenuService) {
    const domain = TRPCONFIG.Domain;
    const url = '/api2/useraccounts/';
    const preferencesUrl = '/api2/useraccounts/preferences/get';
    let bufferedRoute = {
        route: null,
        reload: false
    };
    let regPromise;
    const signInLevel = {
        None: 0,
        Soft: 1,
        Hard: 2
    };

    let skywardsResult;


    broker.subscribe('authService', 'bookingComplete', function() {
        $timeout(function() {
            let cu = currentUser.get();
            let userToExtend = {
                Agent: cu ? cu.Agent : null,
                AnonSignedIn: !!cu && cu.AnonSignedIn,
                BookingId: getSignedInBookingId()
            };
            _extendUser(userToExtend);
        }, 2000);
    });

    broker.subscribe('authService', 'agentSignIn', signOut);


    const service = {
        register,
        registerForNewsletter,
        unsubscribeFromNewsletter,
        signin,
        socialSignin,
        verify,
        forgotPassword,
        changeEmail,
        changePasswordWithToken,
        changePassword,
        signOut,
        changeContactDetails,
        changeContactInfo,
        deleteAccount,
        getUser,
        setUser,
        getUrl,
        bufferRoute,
        anonSignIn,
        bookingSignInByAgent,
        getNextRoute,
        newsletterSignUp,
        redirectToBufferedRoute,
        getSignedinBooking,
        impersonatedSignIn,
        getUserByAgent,
        anyEndUser,
        getSignedInBookingId,
        doesHttpOnlyCookieExist,
        checkUserPreferences,
        createCookieName,
        getSkywardsUserDetails,
    };

    function _postRequest(path, data, options) {
        if (data) {
            data.CultureCode = domain.CultureCode;
            data.TenantId = domain.TenantId;
        }
        return $http
            .post(url + path, data, options || {})
            .then(function(res) {
                return res.data;
            });
    }

    function _extendUser(user) {
        return $http
            .get(`${url}getsignedinuser`)
            .then(async function(res) {
                user.Provider = res.data.Identity.Provider;
                user.Email = res.data.Identity.Email;
                user.UserIdHash = res.data.Identity.UserIdHash;
                user.EmailHash = res.data.Identity.EmailHash;
                user.HardSignedIn = res.data.SigninLevel === signInLevel.Hard;
                user.SoftSignedIn = res.data.SigninLevel >= signInLevel.Soft;
                user.ImpersonatedSignedIn = !!res.data.Identity.IsImpersonated;
                user.SignedIn = user.HardSignedIn || user.SoftSignedIn || user.ImpersonatedSignedIn;
                //soft signed in - Contact.Email is not populated, but Identity.Email always is, so don't overwrite it
                if (res.data.Contact) {
                    delete res.data.Contact.Email;
                }
                user = angular.extend(user, res.data.Contact);
                currentUser.set(user);
                broker.publish('userExtended', user);
                skywardsResult = await res;
                if (!sessionStorage.getItem('skywardsLoginUser')) {
                    sessionStorage.setItem('skywardsLoginUser', JSON.stringify(skywardsResult));
                }

                return user;
            });
    }

    function _updateUserFromResponse(user) {
        if (user != null) {
            user.Contact = user.Contact || {};
            const hard = user.SigninLevel === signInLevel.Hard;
            const soft = user.SigninLevel >= signInLevel.Soft;
            const existUser = currentUser.get();
            user.Contact = user.SigninLevel < signInLevel.Soft && !!existUser
                ? angular.extend(user.Contact, {
                    AnonSignedIn: existUser.AnonSignedIn,
                    Contact: existUser.Contact,
                    BookingSummary: existUser.BookingSummary
                })
                : angular.extend(user.Contact, { AnonSignedIn: false });
            currentUser.set(angular.extend(user.Contact, {
                Provider: 'TRP',
                Agent: existUser ? existUser.Agent : null,
                Email: user.Identity.Email,
                UserIdHash: user.Identity.UserIdHash,
                EmailHash: user.Identity.EmailHash,
                HardSignedIn: hard,
                SoftSignedIn: soft,
                ImpersonatedSignedIn: !!user.Identity.IsImpersonated,
                SignedIn: hard || soft || !!user.Identity.IsImpersonated
            }));
            broker.publish('userExtended', user);
            preferences.clear();
            $rootScope.user = currentUser.get();
            $rootScope.$broadcast('auth:signin', user.Contact);
        }
    }

    function register(createRequest) {
        return regPromise || (regPromise = _postRequest('register', createRequest)
            .then(function(res) {
                regPromise = null;
                if (res.Result === 0) {
                    _updateUserFromResponse(res.User);
                }
                return res;
            }));
    }

    function registerForNewsletter(createRequest) {
        if (createRequest) {
            createRequest.CultureCode = domain.CultureCode;
            createRequest.TenantId = domain.TenantId;
            createRequest.DomainId = domain.DomainId;
        }
        return $http.post(`${url}registerfornewsletter`, createRequest, { ignoreErrors: true });
    }

    function unsubscribeFromNewsletter(createRequest) {

        return $http.post(
            `${url}unsubscribe`,
            _.assignIn({}, createRequest, { DomainId: domain.DomainId }),
            {
                ignoreErrors: false
            }
        );
    }

    function verify(verifyRequest) {
        return _postRequest('verify', verifyRequest).then(function(res) {
            if (res.Success) {
                _updateUserFromResponse(res.User);
            }
            return res;
        });
    }

    function afterPostSignin(res) {
        if (0 === res.Result) {
            if (currentUser.get() && currentUser.get().AnonSignedIn) {
                $http.post('/api2/managebooking/signout');
            }
            return discountsService.getDiscountCodeForUser().then(() => {
                _updateUserFromResponse(res.User);
                if ($location.search().cb) {
                    // if cb starts with '?' redirect to homepage
                    $location.url($location.search().cb.indexOf('?') ? $location.search().cb : '');
                } else {
                    redirectToBufferedRoute();
                }
                criteoService.enqueue(currentUser.get(), 'signin');
                if (currentUser.get().Email) {
                    analytics.setMixpanelEmail(currentUser.get().Email);
                }
                bufferedRoute.route = null;
                return res;
            });
        }
        return res;
    }

    function signin(signInRequest) {
        return _postRequest('signin', signInRequest)
            .then(afterPostSignin);
    }

    function socialSignin(signInRequest) {
        return _postRequest('externalsignin', signInRequest)
            .then(afterPostSignin);
    }

    function forgotPassword(req) {
        return _postRequest('initiatechangepassword', req);
    }

    function changeEmail(req) {
        return _postRequest('changeemail', req)
            .then(function(res) {
                if (res.Result === 0) {
                    currentUser.set({ SignedIn: false });
                    $rootScope.$broadcast('auth:signout');
                    $location.path('changeemailsent');
                }
                return res;
            });
    }

    function changePasswordWithToken(req) {
        return _postRequest('changepasswordwithtoken', req)
            .then(function(res) {
                if (res.Result === 0) {
                    _updateUserFromResponse(res.User);
                }
                return res;
            });
    }

    function clearAllBrowserSessions(e) {
        if (e.key === 'clear-sessions' && e.newValue === 'session-cleared') {
          _updateUserSignedOut();
        }
    }

    $window.addEventListener('storage', clearAllBrowserSessions);

    function changePassword(req) {

        return _postRequest('changepassword', req).then(function(res) {
            if (res.Result === 0) {
                localStorage.setItem('clear-sessions', 'session-cleared');
                _updateUserSignedOut();
                if ($route.current.requiresHardAuth || $route.current.requiresAnonAuth) {
                    $location.path('/signin');
                }
            }
            return res;
        });
    }

    function signOut(req) {
        const promises = [];
        if (currentUser.get().SignedIn) {
            promises.push(_postRequest('signout', req));
        }

        if (currentUser.get().AnonSignedIn) {
            promises.push($http.post('/api2/managebooking/signout'));
        }

        if (currentUser.get().HardSignedIn) {
            closeSkywardsOktaSession();
            sessionStorage.removeItem('skywardsLoginUser');
        }

        return $q
            .all(promises)
            .then(() => {
                discountsService.validate(TRPCONFIG.DiscountCode);
            })
            .then(function() {
                _updateUserSignedOut();
                if ($route.current.requiresHardAuth || $route.current.requiresAnonAuth) {
                    $location.path('');
                }
                sessionStorage.removeItem('isBetaDomain');
            });
    }

    function changeContactDetails(c) {
        return _postRequest('setcontact', c);
    }

    function changeContactInfo(c) {
        return _postRequest('setcontactinformation', c, { customErrCallback: () => true });
    }

    async function getSkywardsUserDetails() {
        try {
            return await skywardsResult;
        } catch (e) {
            console.log('failed to fetch User details', e);
        }
    }

    function closeSkywardsOktaSession() {
        let url = `${TRPCONFIG.Domain.SkywardsOktaBaseUri}/api/v1/sessions/me`;
        let xhr = new XMLHttpRequest();

        xhr.open('DELETE', url, true);
        xhr.withCredentials = true;
        xhr.send(null);
    }

    function _updateUserSignedOut() {

        currentUser.set(angular.extend({}, currentUser.get(), {
            SignedIn: false,
            AnonSignedIn: false,
            HardSignedIn: false,
            SoftSignedIn: false,
            ImpersonatedSignedIn: false,
            Contact: null
        }));

        preferences.clear();
        $rootScope.$broadcast('auth:signout');
        $rootScope.user = currentUser.get();
        const signedOut = localStorage.getItem('clear-sessions');
        if (signedOut === 'session-cleared') {
            $timeout(localStorage.removeItem('clear-sessions'), 500);
        }
    }

    function deleteAccount(req) {
        return _postRequest('delete', req)
            .then(function(res) {
                if (res.Success) {
                    _updateUserSignedOut();
                    $location.path('');
                }
                return res;
            });
    }

    function getUser() {
        return currentUser.get();
    }

    function setUser(user) {
        currentUser.set(user);
        const path = 'holidays/book';
        const trip = JSON.parse(localStorage.getItem('trip') || '{}');
        if (TRPCONFIG.Domain.EnableRedirectToOldSessionFix && trip && trip.TripId &&
        window.location.pathname.includes(path) &&
        !window.location.pathname.includes(trip.TripId)) {
            $location.path(`${path}/${trip.TripId}`);
        }
        if (user.SignedIn) {
            if (user.AnonSignedIn && user.SigninLevel >= signInLevel.Soft) {
                //Only if the user is not impersonated
                $http.post('/api2/managebooking/signout');
            }
            _extendUser(user);
        }

    }

    function getUrl() {
        return url;
    }

    function bufferRoute(r, reload = false) {
        bufferedRoute.route = r;
        bufferedRoute.reload = reload;
    }

    function redirectToBufferedRoute() {
        const redirect = !!(bufferedRoute.route && bufferedRoute.route.indexOf('?'));
        if (redirect) {
            if (bufferedRoute.reload) {
                //Relaoding the location immediately after $location.path will fail in some browser.
                window.location.href = bufferedRoute.route;
            } else {
                const parsedUri = urlUtils.parse(bufferedRoute.route);
                $location.path(parsedUri && parsedUri.url).search(parsedUri.qs);
            }
        }
        return redirect;
    }

    function bookingSignInByAgent(bookingId) {
        return $http.post('api2/bookings/manage/signinByAgent', {
                    BookingId: bookingId
                }).then(res => {
                    return res;
                })
                .then(res => _signInResult(res, bookingId));
    }

    function anonSignIn(bookingRef, lastName) {
        const user = currentUser.get();

        return (user.SignedIn ?
            _postRequest('signout') :
            $q.when()).then(() =>
                $http.post('/api2/bookings/manage/signinv2', {
                BookingRef: bookingRef,
                Surname: lastName,
                DomainId: TRPCONFIG.Domain.DomainId
                }).then(res => _signInResult(res, bookingRef)));
    }

    function _signInResult(res, bookingId) {
        let bookingNo = document.querySelector('.bookingNumber').value;
        let surname = document.querySelector('.surname').value;
        bookingNo = `BND/${bookingNo}`;

        if (res.data.Success && bookingId !== bookingNo ||
            !res.data.Success && bookingId !== bookingNo) {
            res.data.Success = false;
            return anonSignIn(bookingNo, surname);
        }

        if (res.data.Summary) {
            res.data.Summary.BookingRef = bookingId;
        }

        if (!res.data.Success) {
            return $q.when(false).then(() => {
                accountMenuService.launchRedirect(res.data.Summary);
            });
        }
        return getSignedinBooking().then(booking => {
            const user = angular.extend({}, currentUser.get(), {
                AnonSignedIn: res.data.Success,
                Contact: booking.Contact,
                BookingSummary: booking.Summary
            });
            setUser(user);
            if (user.AnonSignedIn) {
                analytics.track('mixpanel', 'UserSignedIn', {
                    IdentityProvider: 'bookingLookup'
                });
                $rootScope.$broadcast('auth:signin', user);
            }
            return user.AnonSignedIn;
        });
    }

    function newsletterSignUp(userId, signupreason = 'Newsletter Signup') {
        const data = {
            UserId: userId,
            Channel: 1,
            Status: 1,
            Source: 'TravelRepublic',
            Reason: signupreason,
            Date: (new Date()).toISOString()
        };

        return $http.post(`${url}Setcommunicationpreference`, data);
    }

    function getNextRoute() {
        return bufferedRoute.route || '';
    }

    function getSignedinBooking() {
        return $http.post('/api2/bookings/manage/getsignedinbookingcontact')
            .then(result => {
                if (result && result.data && result.data.Summary) {
                    if (result.data.Summary.DomainBookedOn.Id === 107) {
                        sessionStorage.setItem('isBetaDomain', true);
                    } else {
                        sessionStorage.removeItem('isBetaDomain');
                    }
                }
                return result && result.data ? result.data : null;
            });
    }

    function getHost() {
        return $location.host();
    }

    function getDomain() {
        const host = getHost();
        let cookieDomain;
        let domainParts;

        if (host.startsWith('pp2.')) {
            cookieDomain = host.replace('pp2.', '.pp2.');
        } else {
            domainParts = host.split('.');
            domainParts.shift();
            cookieDomain = `.${domainParts.join('.')}`;
        }
        return cookieDomain;
    }

    function createCookieName() {
        let domainParts;
        const host = getHost();
        const devEnv = _.get(TRPCONFIG, 'Domain2.CookieEnv');
        domainParts = host.split('.');
        const match = domainParts.some(part => devEnv && devEnv.includes(part));
        const devEnvStr = (match) ? 'DEV' : '';
        return `${devEnvStr}.ASPXAUTH`;
    }

    const getUserPreferences = async () => {
        const response = await fetch(preferencesUrl);
        const { status } = response;
        if (status === 401 || status === 403) {
            return status;
        }
    };

    async function checkUserPreferences() {
        const enabled = _.get(TRPCONFIG, 'Domain2.ClearUserPrefs');
        if (!enabled) { return; }
        let getUserPrefResponse;
        const user = getUser();
        const signedIn = _.get(user, 'SignedIn');
        if (signedIn) {
            getUserPrefResponse = await getUserPreferences();
        }
        if (getUserPrefResponse && signedIn === true) {
            _updateUserSignedOut();
            $location.path('/signin');
        }
    }

    function doesHttpOnlyCookieExist(cookiename) {
        const enabled = _.get(TRPCONFIG, 'Domain2.ClearUserPrefs');
        if (!enabled) { return; }
        const cookieDomain = getDomain();
        const duration = dateUtil.addDays(new Date(), 14);
        const expires = `expires= + ${duration}`;
        cookieService.set(cookiename, 1, expires, cookieDomain);
        const cookies = `${document.cookie}`;

        let cookieASPXAUTH = cookieService.get(cookiename, cookies);
        const user = currentUser.get();
        const requiresHardAuth = _.get($route, 'current.requiresHardAuth');
        const requiresAnonAuth = _.get($route, 'current.requiresAnonAuth');

        if (cookieASPXAUTH !== null && _.get(user, 'SignedIn')) {
            _updateUserSignedOut();
            if (requiresHardAuth || requiresAnonAuth) {
                $location.path('/signin');
            }
        }
    }

    function impersonatedSignIn(userId) {
        return _postRequest('impersonatedsignin', { userId })
            .then(res => {
                if (res.Success === false) {
                    broker.publish('userDeimpersonated', null);
                } else {
                    _updateUserFromResponse(res.User);
                }
                return res;
            });
    }

    function getUserByAgent(userId) {
        return $http.get(`${url}getuserbyagent?request.userId=${userId}`, { ignoreErrors: true });
    }

    //True, if there is either Travel agent / Customer is selected
    function anyEndUser() {
        return TRPCONFIG.Domain.IsTravelAgentMode || (!!currentUser.get() && currentUser.get().ImpersonatedSignedIn);
    }

    function getSignedInBookingId() {
        let user = getUser();
        return user && user.AnonSignedIn ? (user.Contact ? user.Contact.BookingId : user.BookingId) : null;
    }

    return service;
}
})();
